import { render, staticRenderFns } from "./Gundem.vue?vue&type=template&id=3af825bd&scoped=true&"
import script from "./Gundem.vue?vue&type=script&lang=js&"
export * from "./Gundem.vue?vue&type=script&lang=js&"
import style0 from "./Gundem.vue?vue&type=style&index=0&id=3af825bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af825bd",
  null
  
)

export default component.exports